<h2 class="text-center mb-4">Select Account</h2>
<div class="py-2 px-4 overflow-auto accountList">
  <div *ngFor="let tenant of accountsGroupedByTenant">
    <h5 class="text-fm-blue mb-0">
      {{ tenant.tenantName }}
    </h5>

    <div
      class="card cursor-pointer shadow-sm rounded-sm p-3 mt-3"
      *ngFor="let account of tenant.accounts"
      (click)="selectAccount(account)"
    >
      <div class="d-flex align-items-center">
        <app-initials-icon
          [user]="{ firstName: account.firstName, lastName: account.lastName }"
          [size]="1.4"
        ></app-initials-icon>
        <div class="ms-3">
          <div>
            <span> {{ account.firstName }} {{ account.lastName }} </span>
          </div>
          <div>
            <small class="fst-italic">{{ account.email }} </small>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="px-4 mt-3">
  <mat-divider></mat-divider>
  <div class="card cursor-pointer shadow-sm rounded-sm p-3 mt-4" (click)="useAnotherAccount()">
    <div class="d-flex align-items-center">
      <mat-icon class="text-fm-blue">add</mat-icon>
      <div class="ms-2">Use Another Account</div>
    </div>
  </div>
</div>
